export default "__VITE_ASSET__DGhB9tRH__"